import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

(function() {
  if (!sessionStorage.length) {
    // Ask other tabs for session storage
    localStorage.setItem('getSessionStorage', String(Date.now()));
    setTimeout(() => {
      initApp();
    }, 200);
  } else {
    initApp();
  }

  if (!detectIEEdge()) {
    window.addEventListener('storage', function(event) {
      if (event.key === 'getSessionStorage') {
        // Some tab asked for the sessionStorage -> send it

        localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
        localStorage.removeItem('sessionStorage');

      } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
        // sessionStorage is empty -> fill it

        const data = JSON.parse(event.newValue);
        // tslint:disable-next-line:forin
        for (const key in data) {
          sessionStorage.setItem(key, data[key]);
        }

        initApp();
      } else if (event.key === 'requestRemoveSession') {
        const data = event.newValue;
        if (data) {
          sessionStorage.removeItem(data);
          window.location.reload();
        }
      }
    });
  }
})();

let numberInitilized = 0;
function initApp() {
  if (numberInitilized > 0) { return; }
  numberInitilized++;
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
}

function detectIEEdge() {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}
